// import React from "react";
// import { Navigate, Outlet } from "react-router-dom";
// import { useAuth } from "hooks/useAuth";
// import { URLS } from "utils/constants";

// const RedirectIfLoggedIn = () => {
//   const { user } = useAuth();

//   // return user ? <Navigate to={URLS.v1.DASHBOARD} replace /> : <Outlet />;
//   return user ? <Navigate to={URLS.v1.BOOKINGV3} replace /> : <Outlet />;
// };

// export default RedirectIfLoggedIn;

import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "hooks/useAuth";
import { getPostLoginRedirect } from "utils/authRedirect";

const RedirectIfLoggedIn = () => {
  const { user } = useAuth();

  if (!user) return <Outlet />;

  return <Navigate to={getPostLoginRedirect(user)} replace />;
};

export default RedirectIfLoggedIn;
